
import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CompanyUsersEntity } from '../../domain/entities/CompanyUsersEntity'
import type { CompanyUserAdminDto } from '@/backend/market'

export class CompanyUsersModel extends CompanyUsersEntity {
  constructor(dataDto: CompanyUserAdminDto) {
    super()
    mapEntityProperties<CompanyUsersModel>(this, dataDto, {
      exclude: ['user', 'mealTier'],
      map: {
        user: dataDto.userId ? {
          id: dataDto.userId,
          displayName: dataDto.userDisplayName
        } : undefined,
        mealTier: dataDto.mealTierId ? {
          id: dataDto.mealTierId,
          name: dataDto.mealTierName
        } : undefined
      }
    })
  }
}